export default __webpack_public_path__ + "static/media/token-swap-fail.51d0099a.png";